import * as React from 'react';
import { redirect, useNavigate } from 'react-router-dom';

export const AuthContext = React.createContext();

export const AuthProvider = ({ children }) => {
    // const navigate = useNavigate();
    const [user, setUser] = React.useState(JSON.parse(sessionStorage.getItem('user')) || null);

    const setUserDetails = (user) => {
        setUser(user);
        if (user) {
            window.sessionStorage.setItem('user', JSON.stringify(user));
        } else {
            window.sessionStorage.removeItem('user');
        }
    };

    const login = (userData) => {
        setUserDetails(userData);
    };

    const signout = () => {
        setUser(null);
        window.sessionStorage.clear();
    };

    React.useEffect(() => {
        const handleStorageChange = () => {
            const storedUser = JSON.parse(sessionStorage.getItem('user'));
            if (!storedUser) {
                setUser(null);
                redirect('/');
            }
        };

        window.addEventListener('storage', handleStorageChange);
        return () => {
            window.removeEventListener('storage', handleStorageChange);
        };
    }, [redirect]);

    return (
        <AuthContext.Provider value={{ user, setUserDetails, login, signout }}>
            {children}
        </AuthContext.Provider>
    );
};





















// import * as React from 'react';
// // import { Navigate } from 'react-router-dom';

// export const AuthContext = React.createContext();

// export const AuthProvider = ({ children }) => {
//     const [user, setUser] = React.useState(JSON.parse(sessionStorage.getItem('user')) || null);

//     const setUserDetails = (user) => {
//         setUser(user);
//         if (user) {
//             window.sessionStorage.setItem('user', JSON.stringify(user));
//         } else {
//             window.sessionStorage.removeItem('user');
//         }
//     };


//     const signout = () => {
//         setUser(null);
//         window.sessionStorage.clear();
//     }

//     return (
//         <AuthContext.Provider value={{ user, setUserDetails, signout }}>
//             {children}
//         </AuthContext.Provider>
//     );
// };








// // import * as React from 'react'
// // export const AuthContext = React.createContext();

// // export const AuthProvider = ({ children }) => {
// //     const [user, setUser] = React.useState(JSON.parse(sessionStorage.getItem('user')) || {});
// //     const setUserDetails = (user) => {
// //         setUser(user);
// //         window.sessionStorage.setItem('user', JSON.stringify(user));
// //     };
// //     const signout = () => {
// //         setUser({});
// //         window.sessionStorage.removeItem("user");
// //     }
// //     return (
// //         <AuthContext.Provider value={{ user, setUserDetails, signout }}>
// //             {children}
// //         </AuthContext.Provider>
// //     );
// // };
